import React, {useEffect, useRef, useState} from "react";
import {Button, InputNumber, Popover, Space, message} from "antd";
import {EditOutlined} from "@ant-design/icons";
import {useStore} from "hooks/useStore";
import {useFetch} from "hooks/useFetch";

export const BlockedBalanceEditPopover = ({courierId, blockedBalance, onSuccess}) => {
    const stores = useStore();
    const [visible, setVisible] = useState(false);
    const [newBlockedBalance, setNewBlockedBalance] = useState(blockedBalance);
    const payloadRef = useRef({});

    useEffect(() => {
        setNewBlockedBalance(blockedBalance);
    }, [blockedBalance]);

    const [updateLoading, , , , runUpdateBlockedBalance] = useFetch({
        fetchFn: () => stores.walletStore.updateCourierWalletBlockedBalance(payloadRef.current),
        initialCall: false,
        callbackFunc: result => {
            if (!result?.success) return; // hata zaten error modal ile gösterildi
            message.success("Bloke bakiye başarıyla güncellendi.");
            setVisible(false);
            onSuccess?.();
        }
    });

    const handleSave = () => {
        payloadRef.current = {courierId, blockedBalance: newBlockedBalance};
        runUpdateBlockedBalance();
    };

    const handleCancel = () => {
        setNewBlockedBalance(blockedBalance);
        setVisible(false);
    };

    return (
        <Popover
            trigger="click"
            placement="bottom"
            visible={visible}
            onVisibleChange={nextVisible => (nextVisible ? setVisible(true) : handleCancel())}
            overlayStyle={{width: "280px"}}
            content={
                <>
                    <div style={{marginBottom: 8}}>Bloke Bakiye :</div>
                    <InputNumber
                        placeholder="Bloke Bakiye"
                        style={{width: "100%"}}
                        value={newBlockedBalance}
                        onChange={value => setNewBlockedBalance(value)}
                        min={0}
                        precision={2}
                        disabled={updateLoading}
                    />
                    <Space style={{marginTop: 12, width: "100%", justifyContent: "flex-end"}}>
                        <Button size="small" onClick={handleCancel} disabled={updateLoading}>
                            İptal
                        </Button>
                        <Button
                            size="small"
                            type="primary"
                            onClick={handleSave}
                            loading={updateLoading}
                            disabled={newBlockedBalance === null || newBlockedBalance === undefined}
                        >
                            Kaydet
                        </Button>
                    </Space>
                </>
            }
        >
            <Button
                type="text"
                size="small"
                icon={<EditOutlined />}
                style={{padding: 0, height: "auto", lineHeight: 1}}
            />
        </Popover>
    );
};
